import {FetchFunction} from '../types'

type YaAuthProps = {
  host: string
  headers: Record<string, string>
}

const createYaAuthMiddleware = (props: YaAuthProps) => {
  const {host, headers = {}} = props

  return <TReq = unknown, TRes = unknown>(fetchFn: FetchFunction<TReq, TRes>): FetchFunction<TReq, TRes> => {
    return function withYaAuth(config) {
      return fetchFn({
        ...config,
        url: `${host}${config.url}`,
        headers: Object.assign(headers, config.headers),
        options: {
          ...config.options,
          credentials: 'include',
        },
      })
    }
  }
}

export default createYaAuthMiddleware
